import { Component } from '@angular/core';
import { HeaderComponent } from '../header/header.component';
import { TopbarComponent } from '../topbar/topbar.component';
import { ViewportComponent } from '../viewport/viewport.component';

@Component({
  selector: 'app-layout',
  imports: [HeaderComponent, TopbarComponent, ViewportComponent],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.css'
})
export class LayoutComponent {

}
